/**
 * SUMMA FX Design Tokens
 * Fuente de verdad para colores, tipografía y espaciados
 *
 * IMPORTANTE: No hardcodear valores. Siempre usar estos tokens.
 */

export const colors = {
  // Brand
  primary: '#f58c23',

  // Backgrounds
  background: '#000000',
  card: '#0d0d0d',
  cardHover: '#1a1a1a',
  surface: '#0d0d0d',
  surfaceHover: '#1a1a1a',

  // Borders
  border: '#333333',
  borderFocus: '#f58c23',

  // Market colors
  marketUp: '#00d26a',
  marketDown: '#ff3b3b',
  marketNeutral: '#a0a0a0',

  // Text
  textPrimary: '#ffffff',
  textSecondary: '#a0a0a0',
  textMuted: '#666666',

  // Status
  success: '#00d26a',
  error: '#ff3b3b',
  warning: '#f58c23',
  info: '#3b82f6',

  // Contribution status colors
  contributionActive: '#10b981',
  contributionStale: '#f59e0b',
  contributionNoprices: '#eab308',

  // Card backgrounds más oscuros
  cardDark: '#0d0d0d',
  cardDarker: '#080808',

  // Colores adicionales para métricas
  metricTrades: '#34d399',   // Trades (esmeralda)
  metricVolume: '#d97706',   // Volume (ámbar oscuro)
  metricPurple: '#a855f7',   // Purple (violeta)
  metricCyan: '#22d3ee',     // Cyan (cian)
} as const

export const typography = {
  fontFamily: {
    sans: "'Inter', 'Helvetica', sans-serif",
    mono: "'SF Mono', 'Monaco', 'Consolas', monospace",
  },
  fontSize: {
    xs: '10px',
    sm: '12px',
    base: '14px',
    lg: '16px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '32px',
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 1.75,
  },
} as const

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  '2xl': '48px',
} as const

export const borderRadius = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  full: '9999px',
} as const

export const shadows = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.3)',
  md: '0 4px 6px rgba(0, 0, 0, 0.3)',
  lg: '0 10px 15px rgba(0, 0, 0, 0.3)',
} as const

export const transitions = {
  fast: '150ms ease',
  normal: '200ms ease',
  slow: '300ms ease',
} as const

export const componentSizes = {
  buttonHeight: '32px',
  inputHeight: '36px',
  iconSize: '20px',
  headerHeight: '40px',
  sidebarWidth: '240px',
} as const

// Gradients
export const gradients = {
  primary: `linear-gradient(180deg, #f58c23 0%, #e07800 100%)`,
  buy: `linear-gradient(180deg, #00d26a 0%, #059669 100%)`,
  sell: `linear-gradient(180deg, #ff3b3b 0%, #dc2626 100%)`,
  cardDark: `linear-gradient(180deg, #0d0d0d 0%, #080808 100%)`,
} as const

// Animation durations
export const animations = {
  priceFlash: '200ms',
  fadeIn: '150ms',
  slideIn: '200ms',
} as const

// Z-index scale
export const zIndex = {
  dropdown: 100,
  modal: 200,
  popover: 300,
  tooltip: 400,
  toast: 500,
} as const
